import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core'
import { ConfirmService } from '@mmx/shared'
import { filter, Subject, takeUntil } from 'rxjs'

@Directive({
  selector: '[mmxConfirmClick]',
  standalone: false,
})
export class ConfirmClickDirective implements OnDestroy {
  @Input()
  public message: string = 'common.are-you-sure'

  @Input()
  public confirmDisabled = false

  @Input()
  public html = false

  @Output()
  public confirm = new EventEmitter<void>()

  private onDestroy$ = new Subject<void>()

  constructor(
    private appConfirmSvc: ConfirmService,
  ) { }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  @HostListener('click', ['$event'])
  public onClick(e: PointerEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (this.confirmDisabled) {
      this.confirm.emit()
      return
    }

    this.appConfirmSvc.confirm({
      message: this.message,
      html: this.html,
    })
      .pipe(
        takeUntil(this.onDestroy$),
        filter((confirm) => confirm),
      )
      .subscribe(() => this.confirm.emit())
  }
}
